import Config from './organization-devices.router';
import options from './organization-devices.component';

const Component = {
    selector: 'dtOrganizationDevicesPage',
    options
};

export {
    Config,
    Component
};
